import PlantCard from "./PlantCard";

function PlantList({ plants, onWater, onDelete, onOpenModal, currentFilter }) {
  const getEmptyMessage = () => {
    if (currentFilter === "needs-water") {
      return "🎉 All plants are happy! None need water right now.";
    }
    if (currentFilter === "healthy") {
      return "💧 No healthy plants - check if some need watering!";
    }
    return "You have not entered any plants yet!";
  };
  return (
    <section className="plant-list-section">
      {plants.length === 0 ? (
        <p className="no-entry">{getEmptyMessage()}</p>
      ) : (
        <div className="plant-grid">
          {plants.map((plant) => (
            <PlantCard
              key={plant.id}
              plant={plant}
              onWater={onWater}
              onDelete={onDelete}
              onOpenModal={onOpenModal}
            />
          ))}
        </div>
      )}
    </section>
  );
}

export default PlantList;
